import React from "react";
import "../styles/portal.css";

const ClientPortal = ({ enabled, page }) => {
    const title = page?.page_title || "Інформація";
    const url = page?.page_url || "";

    if (!enabled || !url) {
        return (
            <div className="portal-container">
                <div className="portal-header">
                    <div className="portal-hint">
                        Ця сторінка ще не налаштована оператором.
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="portal-container">
            <div className="portal-header">
                <div className="portal-actions">
                    <a className="portal-link" href={url} target="_blank" rel="noreferrer">
                        На сайт
                    </a>
                </div>
            </div>

            <div className="portal-frame-wrap">
                <iframe
                    title={title}
                    src={url}
                    className="portal-iframe"
                    loading="lazy"
                    referrerPolicy="no-referrer"
                />
            </div>
        </div>
    );
};

export default ClientPortal;
